export default "__VITE_ASSET__BMtHQq4___"